// Datos de sesión que se guardan en el navegador al iniciar sesión.
// Todos los "cerrar sesión" pasan por aquí: antes cada menú borraba su propia lista y el del menú
// principal se dejaba el refreshToken, con lo que la sesión se podía renovar después de cerrarla.
export const SESSION_KEYS = ['token', 'refreshToken', 'userId'];

export const clearSession = () => {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
};
